// extracted by mini-css-extract-plugin
export default {"common_input":"InputField_common_input__UlpOD","common_label":"InputField_common_label__008G5"};